/**
 * El aviso de Resultados sobre los que reciben este envío sin haber dado permiso (`sinOptIn` de la respuesta de
 * `send`): pasan por todos los gates y se les manda con `optIn` vacío, cosa que sólo pasa con la política
 * «declarada». Con la estricta es siempre 0 y el aviso no sale.
 *
 * Decía «45 clientes que nunca te dieron permiso para escribirles», y en la recorrida de QA el reporte del mismo
 * análisis decía «a otros 46 nunca se les preguntó»: el mismo nombre para dos cuentas distintas. El reporte cuenta a
 * todos los que tienen mail o celular sin el dato; acá son sólo los que están en ESTE envío (el que falta quedó afuera
 * por una baja; podría haber sido otra promoción reciente, un celular repetido, el canal elegido o que ya lo había
 * recibido). Ahora el título dice que son «de los que reciben este envío», y el detalle, por qué no coincide con el
 * reporte. No cambia a quién se le manda: eso es de `send` (`activa.service.ts`).
 */

import { num, plural } from "./format";

export function avisoSinPermiso(n: number): { titulo: string; detalle: string } | null {
  const k = Number(n);
  if (!Number.isFinite(k) || k <= 0) return null;
  return {
    titulo: `${num(k)} de los que reciben este envío nunca te ${plural(k, "dio permiso para escribirle", "dieron permiso para escribirles")}`,
    detalle:
      "Tampoco te lo negaron. Son sólo los de este envío: el reporte suma también a los que quedan afuera por una baja, " +
      "otra promoción reciente, un celular repetido, el canal que elegiste o porque ya lo recibieron. " +
      "La ley argentina de datos personales pide tener ese permiso antes de mandar: conviene pedirlo.",
  };
}
